import React from 'react';
import { Modal, Select } from 'antd';
import { getReplacedString } from '../../helpers/getReplacedString';
import styles from './AvailableDocumentationModal.module.scss';

const { Option } = Select;

const AvailableDocumentationModal = ({
  visible,
  modalTitle,
  okBtnText,
  selectTitle,
  selectPlaceholder,
  selectedItems,
  items,
  onSelectChange,
  onCancel,
  onOk,
  modalProps = {},
}) => {
  return (
    <Modal
      visible={visible}
      okText={okBtnText || 'Ok'}
      title={modalTitle || 'Доступные документы'}
      okButtonProps={{ disabled: selectedItems.length === 0 }}
      onCancel={onCancel}
      onOk={onOk}
      maskClosable={false}
      {...modalProps}
    >
      {selectTitle && <p className={styles.title}>{selectTitle}</p>}
      <Select
        mode="multiple"
        showSearch
        className={styles.select}
        placeholder={selectPlaceholder || ''}
        onChange={onSelectChange}
        value={selectedItems}
        optionFilterProp="children"
        filterOption={(input, option) => {
          const value = getReplacedString(input);
          const name = getReplacedString(option.props.children);
          return name.indexOf(value) >= 0;
        }}
      >
        {items?.map((item) => (
          <Option key={item.id} value={item.id} item={item}>
            {item.name}
          </Option>
        ))}
      </Select>
    </Modal>
  );
};

export default AvailableDocumentationModal;
